import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-popup',
  templateUrl: './custom-popup.component.html',
  styleUrls: ['./custom-popup.component.sass']
})
export class CustomPopupComponent implements OnInit {

  message: string

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string, private _snackRef: MatSnackBarRef<CustomPopupComponent>) {
    this.message = data;
  }

  ngOnInit(): void {
  }

  close() {
    this._snackRef.dismiss();
  }

}
